import { Item, Indicator } from '@radix-ui/react-radio-group';
import * as React from 'react';
import { cn } from '@discover-lib/utils';

type ItemType = typeof Item;

export type RadioGroupItemProps = React.ComponentPropsWithoutRef<ItemType>;

const RadioGroupItem = React.forwardRef<React.ElementRef<ItemType>, RadioGroupItemProps>(
  ({ className, ...props }, ref) => (
    <Item
      ref={ref}
      className={cn(
        'aspect-square size-5 rounded-full border border-primary text-primary ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}>
      <Indicator className="flex items-center justify-center">
        <span className="size-2 rounded-full bg-blue" />
      </Indicator>
    </Item>
  )
);

RadioGroupItem.displayName = Item.displayName;

export default RadioGroupItem;
